import {useContext} from "react";
import {Link} from "react-router-dom";
import AppConfigContext from "../context/AppConfigContext";
import styles from './Logo.module.scss';

const Logo = ({size, state}) => {
    const { config } = useContext(AppConfigContext);
    const { clientName, logo, logoLink, logoText, logoWidth, logoHeight, stateInfo } = config;

    let logoToUse = logo;
    if (state && stateInfo && stateInfo[state] && stateInfo[state].logoName) {
        logoToUse = require(`../assets/images/${stateInfo[state].logoName}`);
    }
    let isSmall = size === "sm";

    return (
        <Link to={logoLink}
              target="_blank"
              className="d-flex justify-content-center align-items-center text-decoration-none">
            <img src={logoToUse}
                 alt={clientName}
                 style={{ width: logoWidth, height: logoHeight, maxWidth: !logoText ? 'none' : 94 }}
                 className={`me-2 ${styles.logo} ${isSmall ? styles.small : ''}`}/>
            {logoText &&
                (<span className={`${styles.logoText} ${isSmall ? styles.small : ''}`}>{logoText}</span>)}
        </Link>
    )
}

export default Logo;
